import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BaseDropdownComponent } from 'shared/dropdown/_base-dropdown.component';


@Component({
  moduleId: module.id,
  selector: 'custom-dropdown',
  templateUrl: 'custom-dropdown.component.html',
  styleUrls: ['custom-dropdown.component.scss']
})
export class CustomDropdownComponent extends BaseDropdownComponent {

  @Input() alignmentRight: boolean = true;
  @Input() icon: string;
  @Input() textIcon: string;
  @Input() placeholder: string = 'Select';
  @Input() arrowColor: string = '';
  @Input() declare selectedItem: any;

  @Output() selectedItemChange = new EventEmitter<any>();
}
